{
  "ar-SA": 84,
  "az-AZ": 25,
  "bg-BG": 65,
  "bn-BD": 39,
  "bn-IN": 39,
  "ca-ES": 84,
  "cs-CZ": 76,
  "da-DK": 28,
  "de-CH": 85,
  "de-DE": 85,
  "el-GR": 80,
  "en": 100,
  "es-ES": 85,
  "eu-ES": 72,
  "fa-IR": 84,
  "fi-FI": 62,
  "fr-FR": 92,
  "gl-ES": 63,
  "he-IL": 84,
  "hi-IN": 86,
  "hu-HU": 67,
  "id-ID": 84,
  "it-IT": 99,
  "ja-JP": 81,
  "kaa": 22,
  "kab-KAB": 56,
  "kk-KZ": 13,
  "km-KH": 56,
  "ko-KR": 75,
  "ku-TR": 59,
  "lt-LT": 35,
  "lv-LV": 53,
  "mr-IN": 84,
  "my-MM": 25,
  "nb-NO": 84,
  "nl-NL": 99,
  "nn-NO": 45,
  "oc-FR": 79,
  "pa-IN": 54,
  "pl-PL": 93,
  "pt-BR": 84,
  "pt-PT": 84,
  "ro-RO": 100,
  "ru-RU": 99,
  "si-LK": 70,
  "sk-SK": 93,
  "sl-SI": 84,
  "sv-SE": 85,
  "ta-IN": 81,
  "th-TH": 59,
  "tr-TR": 88,
  "uk-UA": 84,
  "uz-UZ": 0,
  "vi-VN": 70,
  "zh-CN": 93,
  "zh-HK": 16,
  "zh-TW": 84
}
